export const SET_SIDENAV = "[SIDE NAV] SET SIDENAV"
export const TOGGLE_SIDENAV = "[SIDE NAV] TOGGLE SIDENAV"
export const TOGGLE_SIDENAV_COLLAPSE = "[SIDE NAV] TOGGLE SIDENAV COLLAPSE"
